import { useState } from 'react';
import { Icon } from '@iconify/react';
import pieChart2Fill from '@iconify/icons-eva/pie-chart-2-fill';
import peopleFill from '@iconify/icons-eva/people-fill';
import personFill from '@iconify/icons-eva/person-fill';
import baselineNewspaper from '@iconify/icons-ic/baseline-newspaper';
import baselinePostAdd from '@iconify/icons-ic/baseline-post-add';
import roundArchive from '@iconify/icons-ic/round-archive';
import baselineDriveEta from '@iconify/icons-ic/baseline-drive-eta';
import baselineBabyChangingStation from '@iconify/icons-ic/baseline-baby-changing-station';
import baselineChildFriendly from '@iconify/icons-ic/baseline-child-friendly';
import baselineChildCare from '@iconify/icons-ic/baseline-child-care';
import baselineFamilyRestroom from '@iconify/icons-ic/baseline-family-restroom';
import { useTranslation } from 'react-i18next';

// ----------------------------------------------------------------------
const DataSidbar = () => {
  const [t, i18n] = useTranslation();
  const [uu, setUu] = useState([]);
  const getIcon = (name) => <Icon icon={name} width={22} height={22} />;
  const userDetails = JSON.parse(localStorage.getItem('user'));
  const userDetails1 = localStorage.getItem('userk');
  const sidebarConfig = [];
  if (userDetails.is_admin) {
    sidebarConfig.push(
      {
        title: t('Statistics'),
        path: '/dashboard',
        icon: getIcon(pieChart2Fill)
      },
      {
        title: t('admin'),
        icon: getIcon(personFill),
        children: [
          {
            title: t('AdminList'),
            path: '/dashboard/admin',
            icon: getIcon(personFill)
          },
          {
            title: t('ajouteradministrateur'),
            path: '/dashboard/add_admin',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('paiement'),
        icon: getIcon(personFill),
        children: [
          {
            title: t('demandedepaiement'),
            path: '/dashboard/paymentRequest',
            icon: getIcon(personFill)
          },
          {
            title: t('validationparcommercial'),
            path: '/dashboard/valide-payment',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementnonvalide'),
            path: '/dashboard/payment-non-valide',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementarchiver'),
            path: '/dashboard/payment-archiver',
            icon: getIcon(personFill)
          },
          {
            title: t('validerpaiementcrèche'),
            path: '/dashboard/valide-payments-creche',
            icon: getIcon(personFill)
          }
        ]
      },
      {
        title: t('Responsabledecrèche'),
        icon: getIcon(baselineChildFriendly),
        children: [
          {
            title: t('Listecrèches'),
            path: '/dashboard/nursery_list',
            icon: getIcon(pieChart2Fill)
          },
          {
            title: t('ajoutercrèche'),
            path: '/dashboard/add_nursery',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('parent'),
        icon: getIcon(baselineFamilyRestroom),
        id: 3,
        children: [
          {
            title: t('Listeparents'),
            path: '/dashboard/parents_list',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('enfant'),
        icon: getIcon(baselineChildCare),
        id: 3,
        children: [
          {
            title: t('Listenfants'),
            path: '/dashboard/children_list',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('nounou'),
        icon: getIcon(baselineBabyChangingStation),
        id: 2,
        children: [
          {
            title: t('Listenounous'),
            path: '/dashboard/nanny_list',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('commercial'),
        icon: getIcon(peopleFill),
        children: [
          {
            title: t('Listecommerciaux'),
            path: '/dashboard/commercial_list',
            icon: getIcon(pieChart2Fill)
          },
          {
            title: t('ajoutercommercial'),
            path: '/dashboard/add_commercial',
            icon: getIcon(pieChart2Fill)
          }
        ]
      }
    );
  } else if (userDetails.is_creche) {
    sidebarConfig.push(
      {
        title: t('crèche'),
        icon: getIcon(baselineChildFriendly),
        children: [
          {
            title: t('parent'),
            icon: getIcon(pieChart2Fill),
            id: 3,
            children: [
              {
                title: t('Listeparents'),
                path: '/dashboard/parents_list',
                icon: getIcon(pieChart2Fill)
              },
              {
                title: t('Listenfants'),
                path: '/dashboard/children_list',
                icon: getIcon(pieChart2Fill)
              }
            ]
          },
          {
            title: t('nounou'),
            icon: getIcon(baselineBabyChangingStation),
            id: 2,
            children: [
              {
                title: t('Listenounous'),
                path: '/dashboard/nanny_list',
                icon: getIcon(pieChart2Fill)
              }
            ]
          },
          {
            title: t('classe'),
            icon: getIcon(pieChart2Fill),
            id: 1,
            children: [
              {
                title: t('Listeclasse'),
                path: '/dashboard/class_list',
                icon: getIcon(pieChart2Fill)
              },
              {
                title: t('Ajouterclasse'),
                path: '/dashboard/add_class',
                icon: getIcon(pieChart2Fill)
              }
            ]
          }
        ]
      },
      {
        title: t('paiement'),
        icon: getIcon(personFill),
        children: [
          {
            title: t('demandedepaiement'),
            path: '/dashboard/paymentRequest',
            icon: getIcon(personFill)
          },
          {
            title: t('validationparcommercial'),
            path: '/dashboard/valide-payment',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementnonvalide'),
            path: '/dashboard/payment-non-valide',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementarchiver'),
            path: '/dashboard/payment-archiver',
            icon: getIcon(personFill)
          }
        ]
      }
    );
  } else if (userDetails.is_commercial) {
    sidebarConfig.push(
      {
        title: t('Dashboard'),
        path: '/dashboard/nursery_dashboard',
        icon: getIcon(pieChart2Fill)
      },
      {
        title: t('paiement'),
        icon: getIcon(personFill),
        children: [
          {
            title: t('demandedepaiement'),
            path: '/dashboard/paymentRequest',
            icon: getIcon(personFill)
          },
          {
            title: t('validationparcommercial'),
            path: '/dashboard/valide-payment',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementnonvalide'),
            path: '/dashboard/payment-non-valide',
            icon: getIcon(personFill)
          },
          {
            title: t('Paiementarchiver'),
            path: '/dashboard/payment-archiver',
            icon: getIcon(personFill)
          },
          {
            title: t('validerpaiementcrèche'),
            path: '/dashboard/valide-payments-creche',
            icon: getIcon(personFill)
          }
        ]
      },
      {
        title: t('crèche'),
        icon: getIcon(baselineChildFriendly),
        children: [
          {
            title: t('Listecrèches'),
            path: '/dashboard/nursery_list',
            icon: getIcon(pieChart2Fill)
          },
          {
            title: t('ajoutercrèche'),
            path: '/dashboard/add_nursery',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('parent'),
        icon: getIcon(baselineFamilyRestroom),
        id: 3,
        children: [
          {
            title: t('Listeparents'),
            path: '/dashboard/parents_list',
            icon: getIcon(pieChart2Fill)
          }
        ]
      },
      {
        title: t('enfant'),
        icon: getIcon(baselineChildCare),
        id: 3,
        children: [
          {
            title: t('Listenfants'),
            path: '/dashboard/children_list',
            icon: getIcon(pieChart2Fill)
          }
        ]
      }
    );
  }
  sidebarConfig.push(
    {
      title: t('Ajouternotification'),
      path: '/dashboard/add_notification',
      icon: getIcon(baselineDriveEta)
    },
    {
      title: t('actualité'),
      path: '/dashboard/actuality',
      icon: getIcon(baselineNewspaper)
    },
    {
      title: t('Ajouterpublication'),
      path: '/dashboard/add_post',
      icon: getIcon(baselinePostAdd)
    },
    {
      title: t('Dashboard'),
      path: '/dashboard',
      icon: getIcon(pieChart2Fill)
    },
    {
      title: t('archive'),
      path: '/dashboard/archive',
      icon: getIcon(roundArchive)
    }
  );
  return sidebarConfig;
};
export default DataSidbar;
